var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "41",
          height: "41",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#f2f2f7",
          "fill-rule": "evenodd",
          d:
            "M10.131.698h20.493c3.398 0 4.633.357 5.872 1.019a6.89 6.89 0 0 1 2.859 2.882c.667 1.243 1.02 2.472 1.02 5.869v20.484c0 3.396-.353 4.63-1.02 5.873a6.95 6.95 0 0 1-2.859 2.858c-1.239.662-2.474 1.015-5.872 1.015H10.131c-3.398 0-4.632-.353-5.876-1.015a6.96 6.96 0 0 1-2.86-2.858c-.667-1.243-1.02-2.477-1.02-5.873V10.469c0-3.396.353-4.625 1.02-5.869a6.91 6.91 0 0 1 2.86-2.882c1.253-.662 2.478-1.02 5.876-1.02z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#ffa89d",
          d:
            "M29.504 31.672H10.246a2.9 2.9 0 0 1-2.871-2.87V16.641a2.9 2.9 0 0 1 2.871-2.87h19.259a2.9 2.9 0 0 1 2.871 2.87v12.161a2.863 2.863 0 0 1-2.871 2.871z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#02016f",
          d:
            "M15.517 13.197c.052.157.052.364.052.573h.992v-.207a2.665 2.665 0 0 1-.052-1.305c.104.157 7.568-.365 6.941.313-.313-.157.104.313 0 .678-.156.104-.104-.574-.209-.365.052-.052 0 .209.052.104-.052.052 0 .104-.104.157.052.157.052.365.052.626h.052c0-.052 0-.157-.052-.209.157-.104.104.104.104.157 0-.104.052 0 .052.052v-.052.052h.835c0-.261 0-.47-.052-.626.157-1.044.574-3.132-1.096-3.236 0 0-7.724-.939-7.62 1.148-.052.679.156 1.514.052 2.14zm7.933-.626v.104c-.052-.052-.052-.052 0-.104zm8.143 9.498h.104c-.052 0-.887-.104-.522-.104h-1.514c-1.827.104-4.332.052-6.211 0-.887 0-1.409-.052-1.983.052.418 0 .052.052.104.052-.626-.157-3.758-.104-3.706-.104-.104-.052-.365 0-.365.052-.47 0 .156-.052.052-.052h-.209.052c-.261.104-.783 0-1.096 0l.157.052c-.157 0-.365 0-.209.052-.783-.104-1.722 0-2.453 0 .209.104-.47-.052-.835-.052.209.052-.731 0-.47.052-.835-.104-1.827-.052-2.714-.052-.679.104-1.931-.104-2.401.157v1.253h5.898c-.104.052.209 0 .104 0h.313c-.209.052.052.209.313.104-.574-.052-.104-.104.052-.052.052-.157 1.827-.052 2.035-.104.365 0-.052.052.052.052-.157.052-1.2.052-.522 0-.104 0-.887-.052-.365.052-.209 0-.47.052-.731.052.104.052.052 0 .261.052-.157-.052.678 0 .417-.052.313.052.47.052.783.052-.313-.052.731-.052.679-.052 0 .052.365.052.052.052h1.566c.313.731-.052 2.401 1.827 2.349 1.618 0 1.566-1.67 1.827-2.401h1.67c.574.052 1.148-.052 1.618 0h.209-.104c.418-.052 1.253 0 1.67-.052.157.052 1.096-.052.783.052 1.044-.104 2.61-.052 3.653 0 .313.104.781.008.938-.044l-.001-1.477c-.157.104-.467.008-.78.06z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }